import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { useUiStore } from '../../store/uiStore'
import { authApi } from '../../api/auth'

export function TopBar() {
  const navigate = useNavigate()
  const { usuario, logout } = useAuthStore()
  const { darkMode, toggleDarkMode, toggleSidebar } = useUiStore()

  async function handleLogout() {
    try {
      await authApi.logout()
    } catch {
      // Si falla el endpoint, igual limpiamos local
    } finally {
      logout()
      navigate('/login')
    }
  }

  return (
    <header className="aura-hairline h-16 bg-surface-card dark:bg-surface-card-dark border-b border-slate-200 dark:border-slate-700 flex items-center justify-between px-4 shrink-0">
      {/* Left: sidebar toggle + breadcrumb placeholder */}
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Right: dark mode + user menu */}
      <div className="flex items-center gap-2">
        <button
          onClick={toggleDarkMode}
          aria-label="Toggle dark mode"
          className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400"
        >
          {darkMode ? '☀' : '🌙'}
        </button>

        <Menu as="div" className="relative">
          <MenuButton className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
            <div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center text-white text-xs font-semibold">
              {usuario?.nombre?.charAt(0).toUpperCase() ?? 'U'}
            </div>
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300 hidden sm:block">
              {usuario?.nombre ?? 'Usuario'}
            </span>
            <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </MenuButton>

          <MenuItems className="absolute right-0 mt-2 w-48 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700 py-1 z-50 focus:outline-none">
            <div className="px-3 py-2 border-b border-slate-100 dark:border-slate-700">
              <p className="text-xs font-semibold text-slate-700 dark:text-slate-300">{usuario?.nombre}</p>
              <p className="text-xs text-slate-400">{usuario?.email}</p>
            </div>

            <MenuItem>
              {({ focus }) => (
                <button
                  onClick={() => navigate('/settings')}
                  className={`w-full text-left px-3 py-2 text-sm ${focus ? 'bg-slate-50 dark:bg-slate-700' : ''} text-slate-700 dark:text-slate-300`}
                >
                  Configuración
                </button>
              )}
            </MenuItem>

            <MenuItem>
              {({ focus }) => (
                <button
                  onClick={handleLogout}
                  className={`w-full text-left px-3 py-2 text-sm ${focus ? 'bg-slate-50 dark:bg-slate-700' : ''} text-danger`}
                >
                  Cerrar sesión
                </button>
              )}
            </MenuItem>
          </MenuItems>
        </Menu>
      </div>
    </header>
  )
}
